<template>
    <div class="footer">
		<div class="footer-cont">
			<div class="cont">
				<div class="cont-left">
					<p class="cont-tit">联系我们</p>
					<p class="cont-txt">中国中医科学院中医药信息研究所 中医药大健康智能研发中心创办并维护</p>
					<div class="cont-txt">
						<span class="txt-label">地 址</span>：
						<span>北京市东城区东直门内南小街16号</span>
					</div> 
					<div class="cont-txt">
						<span class="txt-label">联系电话</span>：
						<span>010-64089619; 13522583261 </span>
					</div>
					<div class="cont-txt">
						<span class="txt-label">QQ交流群</span>：
						<span>674064836</span>
					</div>
				</div> 
				<div class="cont-right">
					<div class="right-code">
						<img width="100%" src="../assets/images/home/lx-code.jpg" alt="">
						<p>联系我们</p>
					</div>
					<div class="right-code">
						<img width="100%" src="../assets/images/home/wx-code.jpg" alt="">
						<p>公众号</p>
					</div>
				</div>
			</div>
			<div class="cont-txt">   
				<span class="txt-label">相关链接</span>：
				<span>
					<!-- <a href="">中国中医科学院中医药信息研究所 </a>  -->
					<a href="https://www.tcmkb.cn/edc/">中医科研病例采集系统</a>
					<a href="https://www.tcmcds.com/cloud/login">中医科信云门诊系统</a>
					<a href="https://www.tcmcds.com/index">中医临床智能辅助决策系统</a>
				</span> 
			</div>
			<div class="cont-txt"> 
				<div>
					<a href="/pages/helpCenter.jsp">帮助中心</a>
					<a href="/pages/aboutUs.jsp">关于我们</a>
					<a href="/pages/aboutUs.jsp">联系我们</a>
					<a  href="/pages/legalNotices.jsp">法律声明</a>
				</div>
			</div>
			<p class="cont-txt">京ICP备05055726-11 Copyright  中医药知识服务平台 All Rights Reserved</p>
		</div>
		 
  </div>
</template>

<script>
export default {

}
</script> 
<style lang="less" scoped>
.footer {
    min-width: 1200px;
    // height: 350px; 
    background: #fff ;  
    background-size:100%;
    background-position-y: bottom;
	margin: 0 auto;
	border-top: 4px solid;
	border-image: linear-gradient(to right, rgb(65, 233, 118), #396de7) 1;
	.footer-cont{
		width: 1200px;
		margin: 0 auto;
		padding:40px 0 60px;

		.cont{
			width: 100%;
			display: flex;
			padding-bottom: 24px;
			border-bottom: 1px solid #ccc;
			margin-bottom: 20px; 
			.cont-left{
				width: 940px;
			}
			.cont-right{
				width: 260px;
				display: flex;
				justify-content: space-between;
				.right-code{
					width: 110px; 
					p{
						text-align: center;
						font-size: 12px;
						font-weight: bold;
						line-height: 16px;
					}
				}
			}
		}
		.cont-tit{
			font-weight:bold;
			font-size: 14px;
			color: #183285;
			line-height: 20px;
			margin-bottom: 14px;
		}
		.cont-txt{
			font-weight: 400;
			font-size: 14px;
			line-height: 32px; 
			display: flex;
			.txt-label{
				width: 66px;
				text-align-last: justify;
			}
			a{
				display: inline;
				height: 32px;
				margin-right: 14px;
			}
		}
	} 
}
 


</style>